export const validateProduct = (product, productTitle) => {
  if (!product.title[product.language]) {
    return "Title can't be blank";
  }
  if (product.speciesIds.length < 1) {
    return "Species is a required field";
  }
  return null;
};
